export default "__VITE_ASSET__24ff0250__"